import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { FlatTypeInfo } from '../../models/polymer/FlatTypeInfo.model'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
interface QueryParams {
  hdb_ref: string
  uinfin: string
  singpass_token: string
}
export const flatTypeApi = createApi({
  reducerPath: 'flatTypeApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "POST");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getFlatTypeApiByHdbRef: builder.query<FlatTypeInfo, QueryParams>({
      query: (queryParams: QueryParams) => (
        {
        method: "POST",
        url:`${SUB_PATH_BASIC}/getFlatType`,
        body:{
          scheme_account: queryParams.hdb_ref,
        },
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      keepUnusedDataFor:1,
    }),
   
  }),
})

export const { useGetFlatTypeApiByHdbRefQuery } = flatTypeApi

